import {
  GET_ATTEVENT,
  GET_ATTEVENT_SUCCESS,
  GET_ATTEVENT_FAIL,
  DELETE_ATTEVENT,
  DELETE_ATTEVENT_SUCCESS,
  DELETE_ATTEVENT_FAIL,
  UPDATE_ATTEVENT,
  UPDATE_ATTEVENT_SUCCESS,
  UPDATE_ATTEVENT_FAIL,
  ADD_NEW_ATTEVENT,
  ADD_ATTEVENT_SUCCESS,
  ADD_ATTEVENT_FAIL,
  ATTEVENT_LOADING,
  ATTEVENT_RESET,
} from "./actionType";

export const resetAttEventState = (actionType) => ({
  type: ATTEVENT_RESET,
  payload: { actionType },
});

export const getAttEventSuccess = (actionType, data) => ({
  type: GET_ATTEVENT_SUCCESS,
  payload: { actionType, data },
});

export const getAttEventFail = (actionType, error) => ({
  type: GET_ATTEVENT_FAIL,
  payload: { actionType, error },
});

export const getAttEvent = data => ({
  type: GET_ATTEVENT,
  payload: data,
});

export const getAttEventLoading = () => ({
  type: ATTEVENT_LOADING
});

export const deleteAttEvent = data => ({
  type: DELETE_ATTEVENT,
  payload: data,
});

export const deleteAttEventSuccess = data => ({
  type: DELETE_ATTEVENT_SUCCESS,
  payload: data,
});

export const deleteAttEventFail = error => ({
  type: DELETE_ATTEVENT_FAIL,
  payload: error,
});

export const updateAttEvent = data => ({
  type: UPDATE_ATTEVENT,
  payload: data,
});

export const updateAttEventFail = error => ({
  type: UPDATE_ATTEVENT_FAIL,
  payload: error,
});

export const updateAttEventSuccess = data => ({
  type: UPDATE_ATTEVENT_SUCCESS,
  payload: data,
});

export const addNewAttEvent = data => ({
  type: ADD_NEW_ATTEVENT,
  payload: data,
});

export const addAttEventSuccess = data => ({
  type: ADD_ATTEVENT_SUCCESS,
  payload: data,
});

export const addAttEventFail = error => ({
  type: ADD_ATTEVENT_FAIL,
  payload: error,
});